(function () {
  if (window.InnerNerdImageZoom) return;

  const zoomSelectors = [
    'img.collection-product-image',
    'img.cart-item__image',
    'img.feat-product-image',
    '.product-gallery__main-image',
    '.card__media img'
  ];

  function injectStyles() {
    if (document.getElementById('innernerd-image-zoom-styles')) return;

    const style = document.createElement('style');
    style.id = 'innernerd-image-zoom-styles';
    style.textContent = `
      html.innernerd-image-zoom-open,
      html.innernerd-image-zoom-open body {
        overflow: hidden;
      }

      ${zoomSelectors.join(',')} {
        cursor: zoom-in;
      }

      .innernerd-image-zoom {
        align-items: center;
        background: rgba(0, 0, 0, .86);
        display: none;
        inset: 0;
        justify-content: center;
        padding: 24px;
        position: fixed;
        z-index: 100000;
      }

      .innernerd-image-zoom.is-open {
        display: flex;
      }

      .innernerd-image-zoom__image {
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 24px 80px rgba(0, 0, 0, .45);
        max-height: 92vh;
        max-width: min(94vw, 920px);
        object-fit: contain;
        padding: 10px;
      }

      .innernerd-image-zoom__close {
        align-items: center;
        background: #ffffff;
        border: 0;
        border-radius: 999px;
        color: #111111;
        cursor: pointer;
        display: inline-flex;
        font-size: 24px;
        font-weight: 900;
        height: 44px;
        justify-content: center;
        line-height: 1;
        position: absolute;
        right: 20px;
        top: 20px;
        width: 44px;
      }

      @media screen and (max-width: 749px) {
        .innernerd-image-zoom {
          padding: 14px;
        }

        .innernerd-image-zoom__image {
          max-height: 88vh;
          max-width: 96vw;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function ensureOverlay() {
    let overlay = document.querySelector('[data-innernerd-image-zoom]');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'innernerd-image-zoom';
    overlay.setAttribute('data-innernerd-image-zoom', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image preview');
    overlay.innerHTML = `
      <button type="button" class="innernerd-image-zoom__close" aria-label="Close image preview">&times;</button>
      <img class="innernerd-image-zoom__image" alt="">
    `;

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target.closest('.innernerd-image-zoom__close')) {
        close();
      }
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  function getLargeSrc(img) {
    const rawSrc = img.dataset.fullSrc || img.currentSrc || img.src;
    if (!rawSrc) return '';

    try {
      const url = new URL(rawSrc, window.location.href);
      if (url.hostname.includes('shopify') || url.searchParams.has('width')) {
        url.searchParams.set('width', '1600');
      }
      return url.toString();
    } catch (error) {
      return rawSrc;
    }
  }

  function findZoomableImage(target) {
    const img = target && target.closest ? target.closest('img') : null;
    if (!img) return null;
    return zoomSelectors.some((selector) => img.matches(selector)) ? img : null;
  }

  function open(img) {
    injectStyles();
    const overlay = ensureOverlay();
    const preview = overlay.querySelector('.innernerd-image-zoom__image');
    const src = getLargeSrc(img);
    if (!preview || !src) return;

    preview.src = src;
    preview.alt = img.alt || 'Product image';
    overlay.classList.add('is-open');
    document.documentElement.classList.add('innernerd-image-zoom-open');
  }

  function close() {
    const overlay = document.querySelector('[data-innernerd-image-zoom]');
    if (!overlay) return;

    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('innernerd-image-zoom-open');
  }

  document.addEventListener('click', (event) => {
    const img = findZoomableImage(event.target);
    if (!img) return;

    event.preventDefault();
    event.stopPropagation();
    open(img);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  window.InnerNerdImageZoom = { open, close };
  injectStyles();
})();
